import { FiatPaymentCardScheme } from '@noah-labs/shared-schema-gql';

export function getFiatPaymentCardScheme(
  scheme: string | undefined,
): FiatPaymentCardScheme | undefined {
  switch (scheme?.toLowerCase()) {
    case 'mastercard':
      return FiatPaymentCardScheme.Mastercard;
    case 'visa':
      return FiatPaymentCardScheme.Visa;
    default:
      return undefined;
  }
}
